import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: "root"
})

export class RedirectMFAGuardService implements CanActivate {

  constructor(private readonly router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      if (route.queryParams["transactionid"] && route.queryParams['token']) {
        return true;
      }
      this.router.navigate(['login']);
    } catch (e) {
      this.router.navigate(['login']);
    }
  }
}
